<template>
  <div class="login-background">
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5" class="text-center">
          <img src="../../assets/logo.png" alt="Logo MasterFit" class="logo-animado" />
          <h2 class="bienvenida">Bienvenido a MasterFit</h2>
        </v-col>
        <v-col cols="12" sm="8" md="5">
          <v-card class="elevation-16 login-card">
            <v-card-title class="justify-center">
              <span class="headline">Iniciar sesión</span>
            </v-card-title>
            <v-card-text>
              <v-form @keyup.enter="iniciarSesion">
                <v-text-field
                  prepend-inner-icon="mdi-account"
                  label="Usuario"
                  v-model="usuario"
                  outlined
                  dense
                  color="primary"
                  @keyup.enter="iniciarSesion"
                />
                <v-text-field
                  prepend-inner-icon="mdi-lock"
                  label="Contraseña"
                  v-model="password"
                  type="password"
                  outlined
                  dense
                  color="primary"
                  @keyup.enter="iniciarSesion"
                />
                <v-btn
                  block
                  large
                  color="black"
                  class="mt-4"
                  @click="iniciarSesion"
                  style="color: white;"
                >
                  <v-icon left>mdi-login</v-icon>
                  INGRESAR
                </v-btn>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3000"
        :color="mensaje.color"
        top
      >
        {{ mensaje.texto }}
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import HttpService from '../../Servicios/HttpService'

export default {
  name: "Login",

  data: () => ({
    usuario: "",
    password: "",
    mensaje: {
      texto: "",
      color: "",
    },
    mostrarMensaje: false
  }),

  methods: {
    iniciarSesion() {
      if (!this.usuario) {
          this.mostrarMensaje = true
          this.mensaje.texto = "Debes colocar el usuario"
          this.mensaje.color = "warning"
          return
      }
      if (!this.password) {
          this.mostrarMensaje = true
          this.mensaje.texto = "Debes colocar la contraseña"
          this.mensaje.color = "warning"
          return
      }
      let payload = {
          metodo: "login",
          usuario: {
              usuario:this.usuario,
              password: this.password
          }
      }
      HttpService.obtenerConDatos(payload, "usuarios.php")
      .then(resultado => {
          if(resultado) {
              this.$emit("logeado", resultado)
          }
      })

      
    },
  },
};
</script>
<style scoped>
/* Fondo degradado moderno */
.login-background {
  min-height: 100vh;
  background: linear-gradient(135deg, #ffd600 0%, #ff9800 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo-animado {
  width: 120px;
  margin-bottom: 16px;
  animation: fadeInDown 1s;
}
.bienvenida {
  color: #fff;
  font-weight: 700;
  margin-bottom: 24px;
  text-shadow: 1px 1px 8px #00000044;
}
.login-card {
  border-radius: 18px;
  animation: fadeInUp 1s;
}
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-40px);}
  to { opacity: 1; transform: translateY(0);}
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(40px);}
  to { opacity: 1; transform: translateY(0);}
}
</style>


// WEBPACK FOOTER //
// src/components/Usuarios/Login.vue